import { ISP_Fan, schemaExhaust } from './types'
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { Fan3D } from './Fan3D';
import { themedUseStyletron } from '../../../theme/customTheme';
import { WiWindy } from 'react-icons/wi'
import { styled } from 'baseui'
import { useMemo } from 'react';
import { schemaFan as schemaFanVarspped } from '../../Devices/DriveVarSpeed';
import { schemaFan as schemaFan2Speed } from '../../Devices/DriveTwoSpeed';
import { schemaFan as schemaFan3Speed } from '../../Devices/DriveThreeSpeed';
import { Aggregate3StateText } from '../../Devices/DriveThreeSpeed/Aggregate3StateText';
import { Aggregate2StateText } from '../../Devices/DriveTwoSpeed/Aggregate2StateText';
import { AggregateVarStateText } from '../../Devices/DriveVarSpeed/AggregateVarStateText';

export function SmallPanel(props: ISP_Fan) {
        const { children, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)
        const [css, theme] = themedUseStyletron();

        const { varSpeed, twoSpeed, threeSpeed } = useMemo(() => {
                const varSpeed = children?.find((v) => v.schema === schemaFanVarspped);
                const twoSpeed = children?.find((v) => v.schema === schemaFan2Speed);
                const threeSpeed = children?.find((v) => v.schema === schemaFan3Speed);
                return { varSpeed, twoSpeed, threeSpeed };
        }, [children]);


        const running = props.isOn;
        const isExhaust = props.schema === schemaExhaust;
        const speed = getSpeedFromFanVar(varSpeed) ?? getSpeedFromFan3Speed(threeSpeed) ?? getSpeedFromFan2Speed(twoSpeed) ?? 60;
        const duration = `${1 / speed * 40}s`;

        return (<div className={css({ display: 'flex', flexDirection: 'column', alignItems: 'center' })}>
                {isExhaust ?
                        <div className={css({ position: 'relative', display: 'flex', flexDirection: 'row' })}>
                                {props.isOn && <div className={css({ position: 'absolute', top: '0px', right: '45px', zIndex: 1 })}>
                                        <AnimatedAirIconExhaust size={'40px'} />
                                </div>}
                                <div className={css({ transform: 'scale(-1, 1)', zIndex: 0 })}><Fan3D duration={duration} width={60} height={60} running={running}></Fan3D></div>
                        </div>
                        :
                        <div className={css({ position: 'relative', display: 'flex', flexDirection: 'row' })}>
                                {props.isOn && <div className={css({ position: 'absolute', top: '0px', right: '-25px' })}>
                                        <AnimatedAirIconSupply size={'40px'} />
                                </div>}
                                <Fan3D width={60} height={60} running={running} duration={duration} ></Fan3D>
                        </div>
                }
                <div className={css({ marginTop: '-5px' })}>
                        {varSpeed && <AggregateVarStateText  {...varSpeed}></AggregateVarStateText>}
                        {threeSpeed && <Aggregate3StateText {...threeSpeed}></Aggregate3StateText>}
                        {twoSpeed && <Aggregate2StateText {...twoSpeed}></Aggregate2StateText>}
                </div>

        </div>);
}


const AnimatedAirIcon = styled(WiWindy, ({ $theme }) => ({
        color: $theme.colors.contentAccent,
        animationDuration: "1.0s",
        marginTop: "-10px",
        animationIterationCount: "infinite",
        animationDirection: "alternate",
        animationTimingFunction: 'ease-in-out',
        animationName: {
                from: { opacity: 0.2, transform: 'scale(1, 1)' },
                to: { opacity: 0.4, transform: 'scale(1.1, 1)' }
        }

}));

const AnimatedAirIconSupply = styled(AnimatedAirIcon, ({ $theme }) => ({
        transformOrigin: 'top left',
}));

const AnimatedAirIconExhaust = styled(AnimatedAirIcon, ({ $theme }) => ({
        transformOrigin: 'top right',
}));

const getSpeedFromFan3Speed = (fan: any) => {
        if (!fan)
                return undefined;
        if (fan.isStep3)
                return 100;
        if (fan.isStep2)
                return 66;
        if (fan.isStep1)
                return 33;
}

const getSpeedFromFan2Speed = (fan: any) => {
        if (!fan)
                return undefined;
        if (fan.isStep2)
                return 100;
        if (fan.isStep1)
                return 50;
}
const getSpeedFromFanVar = (fan: any) => {
        if (!fan)
                return undefined;
        if (fan.actSpeed)
                return fan.actSpeed;
        if (fan.setSpeed)
                return fan.setSpeed;
}